import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [authenticatorDevicesAllIds, authenticatorDevicesById, allAuthenticatorDevicesSelector] =
  resourceSelectors('authenticatorDevices');
